import {
	IListAttrs,
	IListColumnConfig,
	IListOperations,
} from '@datachain/ui-sdk/common';
import { immerable, produce } from 'immer';
import { Map } from 'immutable';

import { FilterModelItemEntity } from './filter-model-item.entity';

export interface ISubscriptionFilterModelListExtra
	extends IListColumnConfig<FilterModelItemEntity> {
	isFixed?: boolean;
	isSelectable?: boolean;
	isSearchable?: boolean;
	isInGroup?: boolean;
	isVisible?: boolean;
	canBeHidden?: boolean;
	canBeReordered?: boolean;
	canBeChosen?: boolean;
	format?: string;
}

interface ISubscriptionFilterModelListEntity
	extends IListAttrs<FilterModelItemEntity> {
	availableColumns: Map<string, ISubscriptionFilterModelListExtra>;
}

const entityDefaults: ISubscriptionFilterModelListEntity = {
	elements: Map(),
	availableColumns: Map(),
};

export class FilterModelListEntity
	implements
		ISubscriptionFilterModelListEntity,
		IListOperations<FilterModelListEntity, FilterModelItemEntity>
{
	private [immerable] = true;
	public elements = entityDefaults.elements;
	public availableColumns = entityDefaults.availableColumns;

	public static build(
		availableCols: Array<ISubscriptionFilterModelListExtra>
	): FilterModelListEntity {
		const inst = new FilterModelListEntity();
		const cols = availableCols.reduce((acc, curr) => {
			acc.push([curr.field, curr]);
			return acc;
		}, new Array<[string, ISubscriptionFilterModelListExtra]>());
		inst.availableColumns = Map(cols);
		return inst;
	}

	private constructor() {}

	public getAvailableColumns(): Map<
		string,
		IListColumnConfig<FilterModelItemEntity>
	> {
		return this.availableColumns;
	}

	public setElements(
		elems: Map<string, FilterModelItemEntity>
	): FilterModelListEntity {
		return produce(this, (draft: FilterModelListEntity) => {
			draft.elements = elems;
		});
	}
}
